// Core packages
import { formatDate } from "@angular/common";
import { AfterViewInit, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import * as FileSaver from "file-saver";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { finalize, take } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { BalancesService } from "src/app/modules/balances/balances.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { DeadlinesService } from "src/app/modules/deadlines/deadlines.service";
import { PricesService } from "src/app/modules/prices/prices.service";
import { openDocumentArchiveDossierDialog } from "src/app/modules/properties/components/document-archive-dossier-dialog/document-archive-dossier-dialog.component";
import { openDocumentArchiveExportContractsDialog } from "src/app/modules/properties/components/document-archive-export-contracts-dialog/document-archive-export-contracts-dialog.component";
import { openDocumentArchiveExportRasDialog } from "src/app/modules/properties/components/document-archive-export-ras-dialog/document-archive-export-ras-dialog.component";
import { ExportCdDocsDialogComponent } from "src/app/modules/properties/components/export-cd-docs-dialog/export-cd-docs-dialog.component";
import { ExportContractsDialogComponent } from 'src/app/modules/properties/components/export-contracts-dialog/export-contracts-dialog.component';
import { ExportRasDocsDialogComponent } from 'src/app/modules/properties/components/export-ras-docs-dialog/export-ras-docs-dialog.component';
import { PrivacyDocsListDialogComponent } from 'src/app/modules/properties/components/privacy-docs-list-dialog/privacy-docs-list-dialog.component';
import { CondoStructuresService } from "src/app/modules/properties/condo-structures.service";
import { guestArchiveLink, guestSearchLink, showsGuestSearch, showsStaffInsert, showsStaffSearch, } from "src/app/modules/properties/document-archive-entries.utils";
import { DocumentArchiveExportDownloadService } from "src/app/modules/properties/document-archive-export-download.service";
import { documentArchiveExportTargetOf, legacyPageExportMenu, } from "src/app/modules/properties/document-archive-export.utils";
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { resolveMappingInfo } from "src/app/modules/properties/property-mapping-info.utils";
import { PropertyRemappingsService } from "src/app/modules/properties/property-remappings.service";
import { StatementsService } from "src/app/modules/properties/statements.service";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { SubscriptionsService } from "src/app/modules/subscriptions/subscriptions.service";
import { SuppliersService } from "src/app/modules/suppliers/suppliers.service";
import { UsersService } from "src/app/modules/users/users.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { Company } from "src/app/shared/models/company/company.model";
import { Property } from "src/app/shared/models/property/property.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ListsService } from "src/app/shared/services/lists.service";
import { DATA_PROCESSOR_APPOINTMENT_TEMPLATE, DEFAULT_PRIVACY_DOC_EXTENSION, PRIVACY_DOC_MIME_EXTENSIONS, PrivacyDocsService } from "src/app/shared/services/privacy-docs.service";
import { ThemeService } from "src/app/shared/services/theme.service";
import { isArchiveV3Live } from "src/app/shared/utils/archive-switch.utils";
var PropertyHomeComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function PropertyHomeComponent(dialog, newMessageDialog, cancelContractDialog, configService, activatedRoute, propertiesService, router, toastrService, helperService, translateService, themeService, authService, cookieService, companiesService, apiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    subscriptionsService, pricesService, balancesService, listsService, userService, deadlinesService, suppliersService, settingsService, documentArchivesService, condoStructuresService, statementsService, privacyDocsService, propertyRemappingsService, documentArchiveExportDownloadService) {
        this.dialog = dialog;
        this.newMessageDialog = newMessageDialog;
        this.cancelContractDialog = cancelContractDialog;
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.propertiesService = propertiesService;
        this.router = router;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.cookieService = cookieService;
        this.companiesService = companiesService;
        this.apiService = apiService;
        this.subscriptionsService = subscriptionsService;
        this.pricesService = pricesService;
        this.balancesService = balancesService;
        this.listsService = listsService;
        this.userService = userService;
        this.deadlinesService = deadlinesService;
        this.suppliersService = suppliersService;
        this.settingsService = settingsService;
        this.documentArchivesService = documentArchivesService;
        this.condoStructuresService = condoStructuresService;
        this.statementsService = statementsService;
        this.privacyDocsService = privacyDocsService;
        this.propertyRemappingsService = propertyRemappingsService;
        this.documentArchiveExportDownloadService = documentArchiveExportDownloadService;
        // Google Map
        // @ViewChild(GoogleMap, { static: false }) map: GoogleMap;
        // @ViewChild(MapInfoWindow, { static: false }) info: MapInfoWindow;
        this.mapZoom = 18;
        this.mapOptions = {
            zoomControl: true,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            mapTypeId: "hybrid",
        };
        this.markers = [];
        // End - Google Map
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.detailCardIsLoading = true;
        this.loggedUserShared = false;
        this.loggedUserTemporary = false;
        this.loggedUserMaster = false;
        this.loggedUserAdmin = false;
        this.loggedUserRoleType = "";
        this.subscriptionDocumentUpload = false;
        this.propertyPrivacyActive = false;
        this.propertyPrivacySagActive = false;
        this.masterOnlySuppliersAndNfcTag = false;
        this.masterOnlySuppliers = false;
        this.masterOnlyNfcTag = false;
        this.property = new Property();
        this.propertyId = "";
        this.addressString = "";
        this.mappatore = "";
        this.lastMappingEditDate = null;
        // Most recent row of the "Elenco rimappature" table, second source of
        // "Mappatore" and "Ultima modifica alla mappatura" (see resolveMappingInfo)
        this.latestRemapping = null;
        this.latestRemappingLoaded = false;
        // True once both the property and the latest remapping are known, so the
        // mapper row never flashes "Non presente" before the remapping arrives
        this.mappingInfoReady = false;
        this.company = new Company();
        this.previousSubscription = {};
        this.subscriptionType = "FREE";
        this.mappaturaOpen = false;
        this.coverImage = "/assets/img/property-sample.png";
        this.dataProcessorAppointmentDownloading = false;
        this.masterAndSubscriptionPrivacy = false;
        /**
         * `subscription.key` of the property for the rules of the «SCARICA» column once the switch is live:
         * `""` for a property with no plan, which the legacy treats as a paid one, `null` until the property
         * has answered. Kept apart from `subscriptionType`, which reads "FREE" in both cases.
         */
        this.exportPlanKey = null;
        /** The Excel being downloaded from the new archive, `null` when none (@see exportFromArchiveV3) */
        this.exportingTarget = null;
        /** The download of that Excel, cancelled when the page closes */
        this.exportSubscription = null;
        /**
         * True once the switch puts the new archive live: the guest buttons then lead to its pages, and the
         * staff's «Ricerca documenti» and «Inserisci nuovo documento» follow its rules
         */
        this.archiveV3Live = isArchiveV3Live();
    }
    Object.defineProperty(PropertyHomeComponent.prototype, "guestArchiveRoute", {
        /**
         * «Archivio fascicolo documentale» of the guests: the legacy dossier until the switch, the new one
         * after it.
         *
         * @since 3.0.0
         */
        get: function () {
            return guestArchiveLink(this.archiveV3Live, this.lang, this.propertyId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyHomeComponent.prototype, "guestSearchRoute", {
        /**
         * «Ricerca documenti» of the guests: the legacy search until the switch, the new one after it.
         *
         * @since 3.0.0
         */
        get: function () {
            return guestSearchLink(this.archiveV3Live, this.lang, this.propertyId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyHomeComponent.prototype, "guestSearchShown", {
        /**
         * Whether the guests see «Ricerca documenti»: always until the switch; after it, only with the
         * permissions of the new search, which temporary roles never hold.
         *
         * @since 3.0.0
         */
        get: function () {
            return showsGuestSearch(this.archiveV3Live, this.loggedUserPermissions);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyHomeComponent.prototype, "staffSearchShown", {
        /**
         * Whether the staff sees «Ricerca documenti»: always until the switch; after it, only with the
         * permissions of the new search.
         *
         * @since 3.0.0
         */
        get: function () {
            return showsStaffSearch(this.archiveV3Live, this.loggedUserPermissions);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyHomeComponent.prototype, "staffInsertShown", {
        /**
         * Whether the staff sees «Inserisci nuovo documento»: always until the switch; after it, with the
         * rule of the bar of the new pages.
         *
         * @since 3.0.0
         */
        get: function () {
            return showsStaffInsert(this.archiveV3Live, this.loggedUserRoleType, this.loggedUserPermissions);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyHomeComponent.prototype, "downloadMenu", {
        /**
         * The entries of the «SCARICA» column as far as the switch decides them: every one, under the rules
         * of the template, until the switch; once it is live, those of the «Esporta» menu of the new dossier,
         * whose routes they then call (@see legacyPageExportMenu).
         *
         * @since 3.0.0
         */
        get: function () {
            return legacyPageExportMenu(this.archiveV3Live, {
                roleType: this.loggedUserRoleType,
                permissions: this.loggedUserPermissions,
                subscriptionKey: this.exportPlanKey,
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PropertyHomeComponent.prototype, "downloadColumnShown", {
        /**
         * Whether the «SCARICA» title is shown: to the staff, as long as the column has at least one entry.
         * Until the switch its first three entries are always there; once it is live, a role may get none.
         *
         * @since 3.0.0
         */
        get: function () {
            if (this.loggedUserTemporary || this.loggedUserShared) {
                return false;
            }
            var menu = this.downloadMenu;
            return (menu.inserted ||
                menu.missing ||
                menu.ras ||
                (this.loggedUserAdmin && menu.contracts) ||
                (this.loggedUserAdmin && this.propertyPrivacyActive) ||
                (this.loggedUserMaster && this.propertyPrivacySagActive));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Init components
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.propertyId = this.activatedRoute.snapshot.params.propertyId;
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("properties.detail.pageTitle"));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
            _this.currentRole = _this.loggedUser.userRoles.find(function (obj) {
                return (obj._id.toString() ===
                    _this.authService.loggedUserRequestedRole$.getValue().toString());
            });
            _this.loggedUserRoleType = _this.currentRole.role.type;
            if (_this.currentRole.role.type === "shared") {
                _this.loggedUserShared = true;
            }
            if (_this.currentRole.role.type === "temporary") {
                _this.loggedUserTemporary = true;
            }
            if (_this.currentRole.role.type === "master" ||
                _this.currentRole.role.type === "collaborator") {
                _this.loggedUserMaster = true;
                if (_this.currentRole.company._id !== "") {
                    _this.subscriptions.push(_this.companiesService
                        .get(_this.currentRole.company._id)
                        .subscribe(function (res) {
                        if (res.status) {
                            _this.companyData = res.data;
                            _this.company.setData(res.data);
                            if (!res.data.subscription.documentUpload &&
                                res.data.subscription.nfcAccess &&
                                res.data.subscription.suppliers) {
                                _this.masterOnlySuppliersAndNfcTag = true;
                            }
                            else if (!res.data.subscription.documentUpload &&
                                !res.data.subscription.nfcAccess &&
                                res.data.subscription.suppliers) {
                                _this.masterOnlySuppliers = true;
                            }
                            else if (!res.data.subscription.documentUpload &&
                                res.data.subscription.nfcAccess &&
                                !res.data.subscription.suppliers) {
                                _this.masterOnlyNfcTag = true;
                            }
                        }
                    }));
                }
            }
            if (_this.currentRole.role.type === "admin" ||
                _this.currentRole.role.type === "operator") {
                _this.loggedUserAdmin = true;
            }
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        // Get requested property data
        this.subscriptions.push(this.propertiesService.get(this.propertyId).subscribe(function (res) {
            if (res.status) {
                // Set permission data
                _this.property.setData(res.data);
                _this.propertyData = res.data;
                // "Mappatore" and "Ultima modifica alla mappatura": computed once
                // the latest remapping is known too (whichever response comes last)
                _this.updateMappingInfo();
                var countryCode = _this.propertyData.address.countryCodeTwo
                    ? _this.propertyData.address.countryCodeTwo
                    : _this.propertyData.address.countryCode;
                _this.addressString = _this.propertyData.address.route + " " + _this.propertyData.address.streetNumber + ",";
                _this.addressString = _this.addressString + " " + _this.propertyData.address.postalCode + " " + _this.propertyData.address.city + ", " + countryCode;
                for (var prop in res.data.subscription) {
                    _this.previousSubscription[prop] = res.data.subscription[prop];
                }
                // The plan as the rules of the exports read it once the switch is live
                _this.exportPlanKey =
                    _this.propertyData.subscription && typeof _this.propertyData.subscription.key === "string"
                        ? _this.propertyData.subscription.key
                        : "";
                if (_this.propertyData.subscription &&
                    _this.propertyData.subscription.key) {
                    _this.subscriptionType = _this.propertyData.subscription.key;
                    if (_this.propertyData.subscription.documentUpload) {
                        _this.subscriptionDocumentUpload = true;
                    }
                    if (_this.subscriptionType === 'PRIVACY' && _this.loggedUserMaster) {
                        _this.masterAndSubscriptionPrivacy = true;
                    }
                }
                _this.propertyPrivacyActive = !!(_this.propertyData.subscription &&
                    (_this.propertyData.subscription.privacy || _this.propertyData.subscription.privacySag));
                _this.propertyPrivacySagActive = !!(_this.propertyData.subscription &&
                    _this.propertyData.subscription.privacySag);
                if (_this.propertyData.structure) {
                    _this.subscriptions.push(_this.condoStructuresService
                        .get(_this.propertyData.structure)
                        .subscribe(function (res) {
                        if (res.status && res.data) {
                            if (res.data.anagrafica &&
                                res.data.anagrafica.files &&
                                Array.isArray(res.data.anagrafica.files) &&
                                res.data.anagrafica.files.length) {
                                _this.coverImage = _this.configService.apiHost + "/" + res.data.anagrafica.files[0].path;
                            }
                            else {
                                _this.coverImage = "/assets/img/property-sample.png";
                            }
                            _this.mappaturaOpen = res.data.open;
                        }
                    }, function (err) {
                        _this.helperService.handleError(err);
                    }));
                }
                _this.detailCardIsLoading = false;
                return;
            }
            // Something bad happened
            // redirect user to home
            _this.detailCardIsLoading = false;
        }, function (err) {
            _this.detailCardIsLoading = false;
        }));
        // Second source of "Mappatore" and "Ultima modifica alla mappatura",
        // requested in parallel with the property
        this.loadLatestRemapping();
        this.markers.push({
            position: {
                lat: 45.4617824,
                lng: 9.1219734,
            },
            label: {
                color: "red",
                text: "Marker label " + (this.markers.length + 1),
            },
            title: "Marker title " + (this.markers.length + 1),
            info: "Marker info " + (this.markers.length + 1),
            options: {
                animation: google.maps.Animation.BOUNCE,
            },
        });
    };
    /**
     * Loads the most recent remapping of the property: the first row of the
     * "Elenco rimappature" table (property-status page) with the table default
     * sort, date desc.
     *
     * The back-end list requires `canReadCondoStructuresList`, as for the table:
     * without it the request is not sent. When the request is not sent, returns
     * no rows or fails (the error is reported as in the rest of the page), the
     * next sources of resolveMappingInfo are used.
     *
     * @since 3.0.0
     */
    PropertyHomeComponent.prototype.loadLatestRemapping = function () {
        var _this = this;
        if (!Array.isArray(this.loggedUserPermissions) ||
            !this.loggedUserPermissions.includes("canReadCondoStructuresList")) {
            this.onLatestRemappingLoaded(null);
            return;
        }
        this.subscriptions.push(this.propertyRemappingsService
            .getList(this.propertyId, 0, 1, "date", "desc")
            .subscribe(function (res) {
            var items = res && res.status && res.data && Array.isArray(res.data.items)
                ? res.data.items
                : [];
            _this.onLatestRemappingLoaded(items.length > 0 ? items[0] : null);
        }, function (err) {
            _this.helperService.handleError(err);
            _this.onLatestRemappingLoaded(null);
        }));
    };
    /**
     * Stores the outcome of loadLatestRemapping and refreshes the mapping info.
     *
     * @since 3.0.0
     *
     * @param remapping Most recent remapping, or null when there is none or it could not be read
     */
    PropertyHomeComponent.prototype.onLatestRemappingLoaded = function (remapping) {
        this.latestRemapping = remapping;
        this.latestRemappingLoaded = true;
        this.updateMappingInfo();
    };
    /**
     * Sets "Mappatore" and "Ultima modifica alla mappatura" once both the
     * property and the latest remapping are known. Called by both responses,
     * which can arrive in any order: the first one to arrive is a no-op.
     *
     * @since 3.0.0
     */
    PropertyHomeComponent.prototype.updateMappingInfo = function () {
        if (!this.propertyData || !this.latestRemappingLoaded) {
            return;
        }
        var mappingInfo = resolveMappingInfo(this.propertyData.propertyStatus, this.latestRemapping);
        this.mappatore = mappingInfo.mapper;
        this.lastMappingEditDate = mappingInfo.lastEditDate;
        this.mappingInfoReady = true;
    };
    /**
     * After view init logic
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.ngAfterViewInit = function () {
        // console.log("ngAfterViewInit");
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.ngOnDestroy = function () {
        // console.log("ngOnDestroy");
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
        if (this.exportSubscription) {
            this.exportSubscription.unsubscribe();
        }
    };
    /**
     * CD Export file
     * export the files of all condominium documents in zip format
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.onExportFile = function () {
        // With the 3.0.0 archive switched on the dossier comes from it, part by part (NEW-M17)
        if (this.archiveV3Live) {
            openDocumentArchiveDossierDialog(this.dialog, this.propertyId);
            return;
        }
        var dialogRef = this.dialog.open(ExportCdDocsDialogComponent, {
            minWidth: "50%",
            maxHeight: "98vh",
            data: {
                propertyId: this.propertyId,
                propertyName: this.propertyData.name,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * Set current user to inactive
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.onDelete = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("properties.detail.deleteTab.confirmDeletion.title"),
                message: this.translateService.instant("properties.detail.deleteTab.confirmDeletion.message"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.subscriptions.push(_this.propertiesService
                .delete(_this.property.getId())
                .pipe()
                .subscribe(function (res2) {
                _this.toastrService.success(res2.message);
                // Once the user is deleted, redirect to list
                _this.router.navigate([
                    _this.lang,
                    "app",
                    "properties",
                    "suspended",
                ]);
                return;
            }, function (err) {
                // Choose one of the following error handling
                // method. The first one shows a message right
                // under the form fields (if the form is properly
                // setted), the second one shows toastr
                // notifications for each error
                // this.helperService.handleFormError(this.passwordForm, err);
                _this.helperService.handleError(err);
            }));
        });
    };
    /**
     * Reactivate current user
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.onReactivate = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("properties.detail.deleteTab.confirmActivation.title"),
                message: this.translateService.instant("properties.detail.deleteTab.confirmActivation.message"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            _this.subscriptions.push(_this.propertiesService
                .activate(_this.property.getId())
                .pipe()
                .subscribe(function (res2) {
                _this.toastrService.success(res2.message);
                // Once the user is deleted, redirect to list
                _this.router.navigate([_this.lang, "app", "properties", "list"]);
                return;
            }, function (err) {
                // Choose one of the following error handling
                // method. The first one shows a message right
                // under the form fields (if the form is properly
                // setted), the second one shows toastr
                // notifications for each error
                // this.helperService.handleFormError(this.passwordForm, err);
                _this.helperService.handleError(err);
            }));
        });
    };
    /**
     * Export properties in a file with given format
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.onExport = function (target, propertyId) {
        var _this = this;
        // With the switch live, the two Excels of the property come from the new archive (NEW-M7)
        var archiveV3Target = this.archiveV3Live ? documentArchiveExportTargetOf(target) : null;
        if (archiveV3Target !== null) {
            this.exportFromArchiveV3(archiveV3Target);
            return;
        }
        // If target is not provided, than just export all properties
        if (!target) {
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileName_1 = this.translateService.instant("properties.list.exportFileName") + " " + date;
            this.subscriptions.push(this.propertiesService.getExport().subscribe(function (res) {
                var fileBlob = res;
                var blob = new Blob([fileBlob], {
                    type: "application/vnd.ms-excel",
                });
                FileSaver.saveAs(blob, fileName_1 + ".xlsx");
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
        else if (target && typeof propertyId !== "undefined") {
            // Handle export for missing/inserted documents
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileName_2 = this.translateService.instant("properties.list." + target) + " " + date;
            this.subscriptions.push(this.propertiesService.getDocExport(target, propertyId).subscribe(function (res) {
                var fileBlob = res;
                var blob = new Blob([fileBlob], {
                    type: "application/vnd.ms-excel",
                });
                FileSaver.saveAs(blob, fileName_2 + ".xlsx");
            }, function (err) {
                _this.helperService.handleError(err);
            }));
        }
    };
    /**
     * «Elenco documenti presenti» and «Elenco documenti obbligatori mancanti» with the switch live: the
     * Excel of the new archive, as the «Esporta» menu of its dossier gives it. One download at a time;
     * the entry is checked again here and not only in the template, as the dossier does: a page left
     * open across a role change must not ask for an Excel the new role is not shown.
     *
     * @since 3.0.0
     *
     * @param target Which Excel
     */
    PropertyHomeComponent.prototype.exportFromArchiveV3 = function (target) {
        var _this = this;
        if (this.exportingTarget !== null || !this.propertyId || !this.downloadMenu[target]) {
            return;
        }
        this.exportingTarget = target;
        if (this.exportSubscription) {
            this.exportSubscription.unsubscribe();
        }
        this.exportSubscription = this.documentArchiveExportDownloadService
            .download(target, this.propertyId)
            .pipe(finalize(function () {
            _this.exportingTarget = null;
        }))
            .subscribe();
    };
    /**
     * RAS docs export in PDF format
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.onExportRAS = function () {
        // With the switch live, the RAS comes from the new archive, in its own dialog (FE-M8)
        if (this.archiveV3Live) {
            if (this.propertyId && this.downloadMenu.ras) {
                openDocumentArchiveExportRasDialog(this.dialog, this.propertyId);
            }
            return;
        }
        var dialogRef = this.dialog.open(ExportRasDocsDialogComponent, {
            width: "700px",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * Word contracts export
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.onExportContracts = function () {
        // With the switch live, the contracts come from the new archive, in their own dialog (FE-M8)
        if (this.archiveV3Live) {
            if (this.propertyId && this.downloadMenu.contracts) {
                openDocumentArchiveExportContractsDialog(this.dialog, this.propertyId);
            }
            return;
        }
        var dialogRef = this.dialog.open(ExportContractsDialogComponent, {
            minWidth: "50%",
            maxHeight: "98vh",
            data: {
                propertyId: this.propertyId,
            },
            disableClose: true,
        });
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            return;
        });
    };
    /**
     * Open the "Elenco documenti Privacy" dialog for this property
     * (Admin/Operatore only, gated in the template via loggedUserAdmin;
     * requires the property's Privacy or Privacy SAG subscription to be active)
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.onOpenPrivacyDocsDialog = function () {
        if (!this.propertyPrivacyActive) {
            return;
        }
        var companyId = this.propertyData && this.propertyData.admin && this.propertyData.admin.company
            ? this.propertyData.admin.company._id
            : undefined;
        if (!companyId) {
            this.toastrService.error(this.translateService.instant("properties.home.privacyDocsDialog.missingCompany"));
            return;
        }
        this.dialog.open(PrivacyDocsListDialogComponent, {
            data: {
                propertyId: this.propertyId,
                companyId: companyId,
            },
            width: "650px",
            disableClose: true,
        });
    };
    /**
     * Download the "Nomina del responsabile del trattamento dei
     * dati" personalized for this property (Master/Collaboratore only,
     * gated in the template via loggedUserMaster; requires the property's
     * Privacy SAG subscription to be active)
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.onDownloadDataProcessorAppointment = function () {
        var _this = this;
        if (this.dataProcessorAppointmentDownloading || !this.propertyPrivacySagActive) {
            return;
        }
        var companyId = this.propertyData && this.propertyData.admin && this.propertyData.admin.company
            ? this.propertyData.admin.company._id
            : undefined;
        if (!companyId) {
            this.toastrService.error(this.translateService.instant("properties.home.privacyDocsDialog.missingCompany"));
            return;
        }
        this.dataProcessorAppointmentDownloading = true;
        this.subscriptions.push(this.privacyDocsService
            .generateDocuments(companyId, [this.propertyId], DATA_PROCESSOR_APPOINTMENT_TEMPLATE)
            .subscribe(function (fileBlob) {
            _this.dataProcessorAppointmentDownloading = false;
            var date = formatDate(new Date(), "yyyyMMddhhmmss", "en-EN");
            var fileNamePrefix = _this.translateService.instant("properties.home.export.dataProcessorAppointment");
            var extension = PRIVACY_DOC_MIME_EXTENSIONS[fileBlob.type] || DEFAULT_PRIVACY_DOC_EXTENSION;
            FileSaver.saveAs(fileBlob, fileNamePrefix + "-" + date + "." + extension);
        }, function (err) {
            _this.dataProcessorAppointmentDownloading = false;
            _this.helperService.handleError(err);
        }));
    };
    /**
     * Prevent redirect to archive if structure is open
     *
     * @since 1.0.0
     */
    PropertyHomeComponent.prototype.onGoToDocumentArchive = function () {
        if (!this.mappaturaOpen) {
            return;
        }
        this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant('dialogs.confirm.mappaturaOpen.title'),
                message: this.translateService.instant('dialogs.confirm.mappaturaOpen.message'),
                btnCancelText: this.translateService.instant('common.cta.close'),
                messageOnly: true,
            },
            width: '500px',
            disableClose: false,
        });
    };
    return PropertyHomeComponent;
}());
export { PropertyHomeComponent };
